/**
 * Created by JasonChou on 16/12/12.
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import page from './stores/page'
import app from './stores/app'
import userInfo from './stores/userInfo'
import editor from './stores/editor'
import common from './stores/common'
import project from './stores/project'
import db_table from './stores/table'
import classStyle from './stores/classStyle'
import events from './stores/events'
export default new Vuex.Store({
  modules: {
    project,
    app,
    page,
    userInfo,
    editor,
    common,
    db_table,
    classStyle,
    events
  },
  // strict: true
}
)



// WEBPACK FOOTER //
// ./src/vuex/store.js